import { RootState } from '../../../../rootReducer';

export const printCodesSelector = (state: RootState) => state.operationsModuleReducer.PrintCodesReducer;
